/**
 * FAB — anchored editorial style. NOT a giant circle.
 * Pill-shaped with hairline border + accent fill. Opens the Capture sheet.
 * UX §3.16 + AC-156.
 */
import { Plus } from '@phosphor-icons/react';
import { cn } from '../../lib/cn';
import { useAppStore } from '../../lib/store';

export interface FABProps {
  className?: string;
  /** Show label alongside the + icon on desktop. */
  label?: string;
}

export function FAB({ className, label = 'Capture' }: FABProps) {
  const open = useAppStore((s) => s.capture.sheetOpen);
  const openSheet = useAppStore((s) => s.openCaptureSheet);

  return (
    <button
      type="button"
      onClick={openSheet}
      aria-label="Open capture"
      aria-haspopup="dialog"
      aria-expanded={open}
      className={cn(
        'fixed z-30',
        'bottom-6 right-6',
        'inline-flex items-center gap-2',
        'pl-4 pr-5 py-3',
        // Pill shape — not a giant circle.
        'rounded-full',
        'bg-accent text-bg',
        'border border-accent',
        'font-sans text-xs uppercase tracking-[0.14em]',
        'transition-[background-color,border-color,opacity] duration-200 ease-out-slow',
        'hover:bg-accent-hover hover:border-accent-hover',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-accent',
        'disabled:opacity-35',
        className,
      )}
    >
      <Plus size={18} weight="regular" aria-hidden />
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
}
